export default [
    {
        path: '/orders',
        name: 'LeadIndex',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Leads',
            fullHeight: true,
        },
        components: {
            default: () => import('@views/leads/LeadsIndex.vue'),
        },
    },
    {
        path: '/orders/create',
        name: 'LeadCreate',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Create lead',
        },
        components: {
            default: () => import('@views/leads/LeadCreate.vue'),
        },
    },
    {
        path: '/orders/:id/view',
        name: 'OrderView',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Order',
        },
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        components: {
            default: () => import('@views/orders/Order.vue'),
        },
    },
];
